import {createContext} from "react";

type BaseModalContextType = {
    /**
     * Calls props.onClose() given by user.
     * User should close the modal manually [by changing the state].
     * @author Kacper Faber
     * @since 0.1.9
    */
    close: () => void;
};

/**
 * Default values
 * @author Kacper Faber
 * @since 0.1.9
*/
const defaults: BaseModalContextType = {
    close: () => { throw new Error('Not implemented!') }
};

/**
 * BaseModalContext to control modal in sub components.
 * @author Kacper Faber
 * @since 0.1.9
*/
const ctx = createContext<BaseModalContextType>(defaults);

export default ctx;